import { getFeaturedWhitepaper } from '@/lib/whitepapers'
import { z } from 'zod'

export const FEATURED_WHITEPAPER_SLUG = getFeaturedWhitepaper().slug

/** @deprecated Use FEATURED_WHITEPAPER_SLUG */
export const DEFAULT_WHITEPAPER_SLUG = FEATURED_WHITEPAPER_SLUG

export const whitepaperLeadSchema = z.object({
  name: z.string().min(1, 'Please enter your name'),
  company: z.string().min(1, 'Please enter your company name'),
  email: z.string().email('Please enter a valid email address'),
})

export type WhitepaperLeadFormData = z.infer<typeof whitepaperLeadSchema>
